import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useLang } from "@/i18n";
import { EmptyInline } from "@/pages/shared";
import { fmt } from "./sesStatus";

const TONE = { send: "text-sky-700", enqueue: "text-foreground", cancel: "text-orange-700", settings: "text-violet-700", mail: "text-emerald-700", edit: "text-amber-700", check: "text-indigo-700", withdraw: "text-slate-500" };

export default function SesLog() {
  const { t } = useLang();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/interfaces/ses/log").then(({ data }) => setRows(data)).catch((e) => toast.error(apiError(e.response?.data?.detail)));
  }, []);
  return (
    <div className="rounded-2xl border border-border bg-card" data-testid="ses-log">
      <p className="px-5 pt-4 text-sm text-muted-foreground">{t("ses_log_desc")}</p>
      <div className="p-5 max-h-[70vh] overflow-y-auto cb-scroll">
        {!rows ? null : rows.length === 0 ? <EmptyInline /> : (
          <ol className="space-y-1.5 font-mono text-xs">
            {rows.map((r) => (
              <li key={r.id} className="grid grid-cols-[9rem_6rem_1fr] gap-3 rounded-lg px-2 py-1.5 hover:bg-muted/40" data-testid={`ses-log-${r.id}`}>
                <span className="text-muted-foreground">{fmt(r.at)}</span>
                <span className={`font-bold uppercase ${TONE[r.action] || ""}`}>{r.action}</span>
                <span className="text-foreground break-words">{r.note} <span className="text-muted-foreground">· {r.user}</span></span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
